export enum CategoryTreeType {
  listCRUD = 1,
  checkboxProductCategories = 2,
  radioParentCategory = 3,
  radioProductMainCategory = 4,
}
